import React, { Component } from 'react'
import { Redirect, Link } from 'react-router-dom'
import '../../assets/css/styles.css'
import Loading from '../ui/Loading.js'
import {FormattedMessage, injectIntl} from 'react-intl';
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import DatePicker from 'react-datepicker'
import 'moment/min/locales'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from "../../commons/config/ConfigBusiness.js";
import LocaleFormat from "../../commons/utils/LocaleFormat.js";
import DropzoneComponent from "react-dropzone-component";
import "dropzone/dist/dropzone.css";
import swal2 from 'sweetalert2'

class ReporteFormulario extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formData: {
				tipoRelato: null,
				tipoOcurrencia: null,
				reportadoPor: '',
				base: null,
				personaInvolucrada: '',
				fecha: null,
				dominio: '',
				descripcion: '',
				adicionales: '',
				adjuntos: []
			},
			tipoRelatos: [
				{ id: 1, value: 'Condições inseguras' },
				{ id: 2, value: 'Comportamento inseguro' },
				{ id: 3, value: 'Relatos em Rota' },
			],
			tipoOcurrencias: [],
			bases: [],
			errors: [],
			configBusinessLoading: true,
			loadingValidacion: true,
			validacion: false,
			loading: false,
			archivos: []
		}

		this.djsConfig = {
			addRemoveLinks: true,
			autoProcessQueue: false,
			dictRemoveFile: this.props.intl.formatMessage({ id: "ReporteFormulario.eliminar_archivo", defaultMessage: "Eliminar Archivo" }),
			dictDefaultMessage: this.props.intl.formatMessage({ id: 'ReporteFormulario.add_file.label_haga_click_aqui_o', defaultMessage: 'Haga click aquí o' })+
				"<br>"+this.props.intl.formatMessage({ id: 'ReporteFormulario.add_file.label_arrastre_un_archivo_a_este_area', defaultMessage: ' arrastre un archivo a este área.' }),
			maxFilesize: 10, // MB
			acceptedFiles: "application/pdf,image/jpeg,image/png",
			accept: function(file, done) {
				if (file.size > 10 * 1024 * 1024) {
					done("El archivo supera el límite de 10 MB");
				} else {
					done();
				}
			}
		};

		this.componentConfig = {
			iconFiletypes: [".pdf", ".jpg", ".jpeg", ".png"],
			showFiletypeIcon: true,
			postUrl: "no-url"
		};

		this.eventHandlers = {
			addedfile: (file) => {
				if (file.size > 10 * 1024 * 1024) {
					if (this.dropzone) {
						this.dropzone.removeFile(file);
					}
					alert(this.props.intl.formatMessage({ id: "ReporteFormulario.error_archivo_tamano", defaultMessage: "El archivo supera el tamaño máximo permitido (10 MB)." }));
					return;
				}
				this.setState((prev) => ({
					archivos: [...prev.archivos, file]
				}));
			},
			removedfile: (file) => {
				this.setState((prev) => ({
				archivos: prev.archivos.filter((f) => f.name !== file.name)
				}));
			},
			init: (dz) => {
				this.dropzone = dz;
			}
		};

		this.handleDatePickerFormChange = this.handleDatePickerFormChange.bind(this);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.handleInputFormChange = this.handleInputFormChange.bind(this);
		this.handleRemoveFile = this.handleRemoveFile.bind(this);
		this.handleFileChange = this.handleFileChange.bind(this);
	}

	handleDatePickerFormChange(event) {
		let date = event ? event.format(): '';
		if(date === "")
			date = null;
		
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.fecha = date;
		this.setState({
			formData: formDataCopy
		});
	}

	handleDatePickerFormRawChange(date) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		if(date === "")
			date = null;
		formDataCopy.fecha = date;
		this.setState({
			formData: formDataCopy
		});
	}

	loadConfigBusiness() {
        this.getConfig();
        this.getConfigBusiness()
            .then(() => {
                this.setState({ configBusinessLoading: false }); // se ha cargado configBusiness
            })
            .catch(() => {
                this.setState({ configBusinessLoading: false }); // ha ocurrido un error al cargar configBusiness
            });
  }

	async getConfigBusiness() {
			// VEC-3455: esta pantalla es pública y puede abrirse con una sesión ya
			// logueada en el mismo navegador. Si hay token, hay que pedir la config
			// completa (autenticada) en vez de la reducida (pública) — de lo
			// contrario se pisa el configBusiness completo que el resto de la app
			// ya tenía en localStorage, y al redirigir de vuelta el Layout explota
			// por acceder a claves que la versión reducida no trae.
			const token = localStorage.getItem('token');
			const url = token
					? Config.get('apiUrlBase') + '/config-business'
					: Config.get('apiUrlBase') + '/commons/config-business';
			const headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
			if (token) { headers['Authorization-Token'] = token; }

			const fetchConfigBusiness = () => {
					return fetch(url, { method: 'GET', headers: headers });
			};

			try {
					const response = await fetchConfigBusiness();
					if (!response.ok) {
							throw new Error('Error al obtener la configuración de entorno');
					}
					const data = await response.json();
					if ((data.jsonDownloaded && data.jsonDownloaded.complete === 'true')
							|| (!data.json && data.json !== "error")) {
							localStorage.setItem("configBusiness", JSON.stringify(data));
					} else {
							throw new Error('Configuración de entorno incompleta');
					}
			} catch (error) {
					console.log('Error en configuración de entorno', error);
			}
	}

	async getConfig() {
			try {
					const response = await fetch('/config/config.json', {
							method: 'GET',
							headers: {
									'Accept': 'application/json',
									'Content-Type': 'application/json',
							},
					});
					const configData = await response.json();
					localStorage.setItem('config', JSON.stringify(configData));
			} catch (error) {
					console.log(error);
			}
	}

	componentWillMount () {
		this.loadConfigBusiness();
		
		if(ConfigBusiness.get('reportarIncidentes.tokenUrl') && this.props.match.params.token){
			const token = this.props.match.params.token;
			if(token === ConfigBusiness.get('reportarIncidentes.tokenUrl')){
				this.setState({validacion: true}, () => {
					this.setState({loadingValidacion: false});
					this.init();
				});
			}else{
				this.setState({loadingValidacion: false});
			}
		} else {
			this.setState({loadingValidacion: false});
		}
	}

	init(){
		fetch(Config.get('apiUrlBase') + '/public/bases/public-select-all', {
				method: 'GET',
				headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
				},
		})
		.then((response) => {
			response.json()
			.then((data) => {
				this.setState({ bases: data });
			})
			.catch((error) => {
				console.log(error);
			});
		});
	}

	handleSelectChange(name, selectedOption) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		if(name === "tipoRelato"){
			formDataCopy.tipoOcurrencia = null;
		}
		if(name === "tipoRelato" && selectedOption){
			this.loadTipoOcurrencia(selectedOption);
		}
		formDataCopy[name] = selectedOption;
		this.setState({
			formData: formDataCopy
		});
	}

	loadTipoOcurrencia(selectedOption){
		if(selectedOption.id === 1){
			this.setState({ tipoOcurrencias: [
				{ id: 1, value: 'Veículos Geral' },
				{ id: 2, value: 'Pneus em más condições' },
			] });
		}else if(selectedOption.id === 2){
			this.setState({ tipoOcurrencias: [
				{ id: 3, value: 'Falta de todos os EPIs' },
				{ id: 4, value: 'Falta de EPI - Bota de Segurança ' },
				{ id: 5, value: 'Falta de EPI - Colete' },
				{ id: 6, value: 'Falta de EPI - Casquete' },
				{ id: 7, value: 'Falta de EPI - Luva' },
				{ id: 8, value: 'EPIs  sendo utilizados incorretamente' },
				{ id: 9, value: 'Não obedecer as sinalizações internas do Hub/site' },
				{ id: 10, value: 'Conduta agressiva ou desrespeitosa' },
				{ id: 11, value: 'Motorista transitando sem cinto de segurança' },
				{ id: 12, value: 'Ajudante transitando sem cinto de segurança' },
				{ id: 13, value: 'Transitar com a porta do baú aberta' },
				{ id: 14, value: 'Danificar vias, bens ou sinalizações internas' },
				{ id: 15, value: 'Uso do celular ou fone de ouvido enquanto dirige' },
				{ id: 16, value: 'Motorista não puxou freio de mão' },
				{ id: 17, value: 'Cinto de segurança “clipado” sem o motorista no veículo' },
				{ id: 18, value: 'Veículo em movimento com farol ou o  pisca alerta desligado' },
				{ id: 19, value: 'Acima do limite de velocidade do Hub/site ou da via' },
				{ id: 20, value: 'Veículo estacionado sem calço de rodas' },
				{ id: 21, value: 'Realização de manobra de risco no site' },
				{ id: 22, value: 'Realização de reparos mecânicos ou transferência de carga entre baterias' },
				{ id: 23, value: 'Subir ou descer escadas sem utilizar o corrimão' },
				{ id: 24, value: 'Auxiliar motoristas a realizar manobras em pátio' },
				{ id: 25, value: 'Não entregar a chave do veículo, inclusive a reserva, no momento do carregamento/descarregamento' },
				{ id: 26, value: 'Parada em local proibido' },
				{ id: 27, value: 'Uso de Adornos' },
			] });
		}else if(selectedOption.id === 3){
			this.setState({ tipoOcurrencias: [
				{ id: 28, value: 'Alagamentos' },
				{ id: 29, value: 'Animais na pista' },
				{ id: 30, value: 'Buraco na via' },
				{ id: 31, value: 'Carga mal acondicionada' },
				{ id: 32, value: 'Cruzamentos perigosos ou confusos' },
				{ id: 33, value: 'Deficiência de iluminação em trechos urbanos ou rodoviários' },
				{ id: 34, value: 'Desmoronamento ou queda de barreira' },
				{ id: 35, value: 'Direção perigosa ou imprudente de outros motoristas' },
				{ id: 36, value: 'Falta de acostamento ou acostamento estreito' },
				{ id: 37, value: 'Falta de áreas seguras para descanso' },
				{ id: 38, value: 'Falta de sinalização (vertical e horizontal)' },
				{ id: 39, value: 'Falta de telefone de emergência ou cobertura de celular' },
				{ id: 40, value: 'Focos Incêndio na beira da pista' },
				{ id: 41, value: 'Pedestres ou ciclistas em áreas perigosas da via' },
				{ id: 42, value: 'Pneus em más condições' },
				{ id: 43, value: 'Problemas elétricos no veículo' },
				{ id: 44, value: 'Problemas mecánicos no veículo' },
				{ id: 45, value: 'Sistema de iluminação do veículo deficiente (faróis, lanternas queimados)' },
				{ id: 46, value: 'Sujidade na pista (óleo, detritos)' },
				{ id: 47, value: 'Trechos em obras e sem sinalização' },
			] });
		}
	}

	handleInputFormChange(event) {
			const target = event.target;
			const name = target.name;
			const value = target.type === 'checkbox' ? target.checked : target.value;
	
			let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
			formDataCopy[name] = value;

			this.setState({
				formData: formDataCopy
			});
	}

	handleFileChange(event) {
		const files = Array.from(event.target.files);
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.archivos = files;
		this.setState({ formData: formDataCopy });
	}

	handleRemoveFile(index) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.archivos.splice(index, 1);
		this.setState({ formData: formDataCopy });
	}

	async handleSubmit(event) {
		this.setState({ loading: true });
		event.preventDefault();
    const data = new FormData();
		Object.keys(this.state.formData).forEach(key => {
			if (key !== "adjuntos") {
				const value = this.state.formData[key];
				if (value && typeof value === "object" && value.value) {
					data.append(key, value.value);
				} else {
					data.append(key, value);
				}
			}
			if (key === "fecha" && this.state.formData.fecha) {
				data.append(key, moment(this.state.formData.fecha).format('YYYY-MM-DD HH:mm:ss'));
			}
		});

    this.state.archivos.forEach((file, index) => {
      data.append(`adjuntos[${index}]`, file);
    });

    try {
			this.setState({ loading: true });
			const response = await fetch(Config.get('apiUrlBase') + '/public/reportar-incidente', {
				method: 'POST',
				body: data,
			});


			const result = await response.json();

			if (!response.ok) throw result;
			this.setState({ redirectTo: "/" });
			swal2.fire(
				this.props.intl.formatMessage({ id: "ReporteFormulario.reporte_enviado", defaultMessage: "Reporte enviado" }),
				'',
				'success'
			);
		} catch (err) {
			swal2.fire(
				this.props.intl.formatMessage({ id: "ReporteFormulario.error_al_enviar", defaultMessage: "Error al Enviar el Reporte" }),
				err.detalle ? err.detalle.join(', ') : '',
				'error'
			);
			console.error(err);
		} finally {
			this.setState({ loading: false });
		}
	}

	render() {
		return (
			<React.Fragment>
				{this.state.redirectTo && <Redirect replace to={this.state.redirectTo} />}
				{this.state.loading && <Loading hideSpinner />}
				{
					this.state.loadingValidacion || this.state.configBusinessLoading ? '' :
					<>
						{this.state.validacion ?
							<div className="app-content content">
								<div className="content-wrapper">
									<div className="content-body">
										<section className="flexbox-container">
											<div className="col-12 d-flex align-items-center justify-content-center p-0">
												<div className="col-12 p-0">
													<div className="card px-2 py-2 m-0" style={{boxShadow: "none"}}>
														<div id="loginLogo" className="card-header border-0 text-center" style={{padding: 0}}>
															<img src={process.env.PUBLIC_URL + "/images/company/logo-login-app.png"} alt="" className="rounded-circle img-fluid center-block" />
														</div>
													</div>
													<div className="bg-white p-2">
														<h2 className=""><b>SafeFeedback</b></h2>
														<form onSubmit={this.handleSubmit.bind(this)} >
															<div className="row">
																<div className="col-12 col-md-3 mb-3">
																	<label className="label-control col-form-label" htmlFor="TipoRelato">
																		<FormattedMessage id="ReporteFormulario.Tipo_de_Relato" defaultMessage="Tipo de Relato"/>:*
																	</label>
																	<Select
																		id="tipoRelato"
																		name="tipoRelato"
																		placeholder={this.props.intl.formatMessage({ id: 'ReporteFormulario.Seleccionar.placeholder', defaultMessage: 'Seleccionar' })}
																		options={this.state.tipoRelatos}
																		valueKey='id'
																		labelKey='value'
																		value={this.state.formData.tipoRelato}
																		onChange={e => this.handleSelectChange('tipoRelato', e)}
																	/>
																</div>
																<div className="col-12 col-md-6 mb-3">
																	<label className="label-control col-form-label" htmlFor="tipoOcurrencia">
																		<FormattedMessage id="ReporteFormulario.Tipo_de_ocurrencia" defaultMessage="Tipo de ocurrencia"/>:*
																	</label>
																	<Select
																		id="tipoOcurrencia"
																		name="tipoOcurrencia"
																		placeholder={this.props.intl.formatMessage({ id: 'ReporteFormulario.Seleccionar.placeholder', defaultMessage: 'Seleccionar' })}
																		options={this.state.tipoOcurrencias}
																		valueKey='id'
																		labelKey='value'
																		value={this.state.formData.tipoOcurrencia}
																		onChange={e => this.handleSelectChange('tipoOcurrencia', e)}
																		disabled={this.state.formData.tipoRelato === null}
																	/>
																</div>
																<div className="col-12 col-md-3 mb-3">
																	<label className="label-control col-form-label" htmlFor="fecha">
																		<FormattedMessage id="ReporteFormulario.fecha" defaultMessage="Fecha"/>:*
																	</label>
																	<DatePicker
																		id="fecha"
																		name="fecha"
																		className="form-control date-picker-placeholder"
																		dateFormat={LocaleFormat.getDateTimePickerFormat()}
																		placeholderText={this.props.intl.formatMessage({ id: 'ReporteFormulario.fecha.placeholder', defaultMessage: 'dd/mm/aaaa HH:mm' })}
																		onChange={(event) => this.handleDatePickerFormChange(event)}
																		onChangeRaw={(e) => e.preventDefault()}
																		selected={this.state.formData.fecha === null ? null : moment(this.state.formData.fecha)}
																		maxDate={moment()}
																		showTimeSelect
																		minTime={moment().startOf('day')}
																		maxTime={
																				this.state.formData.fecha && moment(this.state.formData.fecha).isSame(moment(), 'day')
																					? moment()
																					: moment('23:59', 'HH:mm')
																		}
																		timeIntervals = { 10 }
																	/>
																</div>
																<div className="col-12 col-md-3 mb-3">
																	<label className="label-control col-form-label" htmlFor="reportadoPor">
																		<FormattedMessage id="ReporteFormulario.Ocurrencia_Reportada_por" defaultMessage="Ocurrencia Reportada por"/>:
																	</label>
																	<input
																		type="text"
																		className="form-control"
																		id="reportadoPor"
																		name="reportadoPor"
																		placeholder={this.props.intl.formatMessage({ id: 'ReporteFormulario.digite_su_nombre.placeholder', defaultMessage: 'DIGITE SU NOMBRE COMPLETO' })}
																		value={this.state.formData.reportadoPor}
																		onChange={this.handleInputFormChange}
																		maxLength={50}
																	/>
																</div>
																<div className="col-12 col-md-3 mb-3">
																	<label className="label-control col-form-label" htmlFor="base">
																		<FormattedMessage id="ReporteFormulario.Unidad" defaultMessage="Unidad"/>:*
																	</label>
																	<Select
																		id="base"
																		name="base"
																		placeholder={this.props.intl.formatMessage({ id: 'ReporteFormulario.Seleccionar.placeholder', defaultMessage: 'Seleccionar' })}
																		options={this.state.bases}
																		valueKey='value'
																		labelKey='descripcion'
																		value={this.state.formData.base}
																		onChange={e => this.handleSelectChange('base', e)}
																	/>
																</div>
																<div className="col-12 col-md-3 mb-3">
																	<label className="label-control col-form-label" htmlFor="personaInvolucrada">
																		<FormattedMessage id="ReporteFormulario.persona_involucrada" defaultMessage="Persona involucrada"/>:
																	</label>
																	<input
																		type="text"
																		className="form-control"
																		id="personaInvolucrada"
																		name="personaInvolucrada"
																		placeholder={this.props.intl.formatMessage({ id: 'ReporteFormulario.nombre_de_la_persona.placeholder', defaultMessage: 'Nombre de la persona' })}
																		value={this.state.formData.personaInvolucrada}
																		onChange={this.handleInputFormChange}
																		maxLength={50}
																	/>
																</div>
																<div className="col-12 col-md-3 mb-3">
																	<label className="label-control col-form-label" htmlFor="dominio">
																		<FormattedMessage id="ReporteFormulario.placa_del_vehiculo" defaultMessage="Placa del vehículo"/>:*
																	</label>
																	<input
																		type="text"
																		className="form-control"
																		id="dominio"
																		name="dominio"
																		placeholder={this.props.intl.formatMessage({ id: 'ReporteFormulario.su_placa.placeholder', defaultMessage: 'Su placa' })}
																		value={this.state.formData.dominio}
																		onChange={this.handleInputFormChange}
																		maxLength={20}
																	/>
																</div>
																<div className="col-12 mb-3 custom-dropzone">
																	<label className="label-control col-form-label" htmlFor="adjuntos">
																		<FormattedMessage id="ReporteFormulario.anexar_archivo" defaultMessage="Anexar archivo"/>:
																	</label>
																	<DropzoneComponent
																		config={this.componentConfig}
																		djsConfig={this.djsConfig}
																		eventHandlers={this.eventHandlers}
																	/>
																</div>
																
																<div className="col-12 mb-3">
																	<label className="label-control col-form-label" htmlFor="descripcion">
																		<FormattedMessage id="ReporteFormulario.Descripcion_resumida" defaultMessage="Descripción resumida"/>:*
																	</label>
																	<textarea
																		className="form-control"
																		id="descripcion"
																		name="descripcion"
																		rows="3"
																		placeholder={this.props.intl.formatMessage({ id: 'ReporteFormulario.descripcion.placeholder', defaultMessage: 'Describa en pocas palabras la ocurrencia' })}
																		value={this.state.formData.descripcion}
																		onChange={this.handleInputFormChange}
																		maxLength={1000}
																	>
																	</textarea>
																</div>

																{/* Campos adicionales */}
																<div className="col-12 mb-3">
																	<label className="label-control col-form-label" htmlFor="adicionales">
																		<FormattedMessage id="ReporteFormulario.campos_adicionales" defaultMessage="Campos adicionales"/>:
																	</label>
																	<input
																		type="text"
																		className="form-control"
																		id="adicionales"
																		name="adicionales"
																		placeholder={this.props.intl.formatMessage({ id: 'ReporteFormulario.adicionales.placeholder', defaultMessage: 'Si usted es Gestor MELI, informe su número de matrícula' })}
																		value={this.state.formData.adicionales}
																		onChange={this.handleInputFormChange}
																		maxLength={255}
																	/>
																</div>
															</div>

															{/* Botones */}
															<div className="d-flex justify-content-end mt-3">
																<button type="button" className="btn btn-outline-secondary mx-2">
																	<FormattedMessage id="ReporteFormulario.cancelar" defaultMessage="Cancelar"/>
																</button>
																<button
																	type="submit"
																	className="btn btn-primary"
																	disabled={
																		this.state.formData.tipoRelato=== null ||
																		this.state.formData.tipoOcurrencia === null ||
																		this.state.formData.fecha === null ||
																		this.state.formData.base === null ||
																		this.state.formData.dominio === '' ||
																		this.state.formData.descripcion === '' ||
																		this.state.loading
																	}
																>
																	{this.state.loading ? (
																		<>
																				<span
																					className="my-spinner me-2"
																					role="status"
																					aria-hidden="true"
																				>
																				</span>
																				<FormattedMessage id="ReporteFormulario.enviando" defaultMessage="Enviando Reporte..."/>
																			</>
																		) : <FormattedMessage id="ReporteFormulario.enviar" defaultMessage="Enviar Reporte"/>
																	}
																</button>
															</div>
														</form>
													</div>
												</div>
											</div>
										</section>
									</div>
								</div>
							</div>
							: 
							<div
									style={{
										width: "100%",
										height: "100%",
										position: "absolute",
										textAlign: "center",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<div>
										<h1 style={{ fontSize: "6rem" }}>
											404aaa -{" "}
											<FormattedMessage
												id="layout.not_found.pagina_no_encontrada"
												defaultMessage="Página No Encontrada!"
											/>
										</h1>
										<Link to="/" style={{ fontSize: "3rem" }}>
											{" "}
											<FormattedMessage
												id="layout.not_found.ir_a_inicio"
												defaultMessage="Ir a Inicio"
											/>
										</Link>
									</div>
								</div>
						}
						</>
				}
			</React.Fragment>
		);
	}
}

export default injectIntl(ReporteFormulario);
